// extracted by mini-css-extract-plugin
export var colors = "'colors.module.css'";
export var orangeText = "#FF5A09";
export var whiteText = "#dcdcdc";
export var cream = "#1d1e22";
export var header = "projects-module--header--DG6oW";
export var bodyText = "projects-module--bodyText--hZ37v";
export var divider = "projects-module--divider--SPQRP";
export var ghContributions = "projects-module--ghContributions--MxqmY";